<template>
  <div class="card">
    <div>
      <div>
        <b-table
          :striped="false"
          :bordered="false"
          :borderless="false"
          :outlined="false"
          :small="false"
          :dark="false"
          :fixed="false"
          :foot-clone="false"
          :no-border-collapse="false"
          :items="items"
          :fields="fields"
          :head-variant="''"
          :busy="isBusy"
          :table-variant="''"
        >
          <template #cell(fullName)="data">
            <span class="expire">{{ data.item.fullName }}</span>
          </template>

          <template #cell(date)="data">
            <span class="expire">{{ data.item.date }}</span>
          </template>
          <template #cell(numberOfTry)="data">
            <span class="expire">{{ data.item.numberOfTry }}</span>
          </template>
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #cell(userImage)="data">
            <img v-if="!data.item.userImage" src="@/assets/images/users/default.png" alt="avatar" class="userImg" />
            <img v-else :src="data.item.userImage" alt="" class="userImg" />
          </template>
          <template #cell(score)="data">
            <span class="expire">{{ data.item.score }}</span>
          </template>
          <template #cell(url)>
            <div>
              <img src="../../../assets/images/result.svg" />
            </div>
          </template>
        </b-table>
        <div style="text-align: center" v-if="items.length === 0 && !isBusy">{{ `هیچ عضوی برای این ${this.$route.query.act === 'exam' ? 'امتحان' : 'نظرسنجی'} وجود ندارد !` }}</div>
      </div>
      <!-- <table style="width: 100%">
        <thead>
          <tr>
            <th>#</th>

            <th>نام و نام خانوادگی</th>

            <th>تاریخ</th>

            <th>تعداد شرکت در امتحان</th>

            <th>نمره</th>

            <th>نتیجه</th>
          </tr>
        </thead>

        <tbody v-if="!examination.length">
          <tr style="">
            {{
              `هیچ عضوی برای این ${this.$route.query.act === 'exam' ? 'امتحان' : 'نظرسنجی'} وجود ندارد !`
            }}
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="(row, index) in examination" :key="index" style="border-bottom: 1px solid #e8e8e8; height: 60px; cursor: pointer" @click="goDetail(row)">
            <td>
              <div style="width: 32px; height: 32px; border-radius: 100%; border: 1px solid #e8e8e8; display: flex; justify-content: center; align-items: center">
                <img v-if="row.userImage" src="row.userImage" />
                <img
                  v-else
                  data-v-ee3a3cce=""
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANXSURBVHgBtZfNTxNBFMDfzHbbQtXURBISD7YYDQQS24uctDYx4SjcvIF/AeUvoP4FlMSDRg/2JhdSDhyMJkg8cTAtEQN+IHvQABHNUoq03e6O87Zu05b9mPLxu2wz8/Z9zL5575WAIPk8C8uh8ihQKQEMYkBYhD/D5iYBFRhR+LMAhr6sHQZz8ThRRfQST8PrRxHZJ01ygxMNg0KayUtN0x/HB7oUVzGnDTPiC9o0AEvBqSCZoRv+Kcddu0WM2i/TJcYgAmcAIaBUNSNpdxr0mPEvpdhZGkdQF+pc47rb91pOQCTycoXBSqEMhY0yqEXDXOu9IkFvjw8Sw90QvkidXrU9iRYHPn2rbLkZ3/hehYW3JdMJO8KXKIzcCUF/nx9cnTjwx61b0nB37Wt1xs34zp4Oc4sHjsYRPBGU2dmrOcqgjXpy1zEdwKP3yva5xSKIgk64w1J1m/8dkGU67Sau/NAa31sElFV+aq4yskTMgGl+i4V5gZlwE/ZSZsfnzaq7ACHjWGuorPHy6oF6IB69xVGVeYmYpZ0CpQkvyaDfs2Ifo0vkHd5XKL+IMS+53h4JOuXaVdlbyGAxCgIVr78vAMEABVGwHvRf93sLEohQkQ4XDBB4cD8EoiRud4uKhoXDwuqWGO7ylBu52w2xgQCIQs1hQgCsBZUyM0/Djd1feie3RiVrm5U8GM6JiKX39ftDKKxXoBPwFLyaE//8BWrUjFWnfaz/z16pHRtH8J3s/L5rXwBKCpQSeAcOxlFBJyW4HXw3O190doLPj1STg7n2PKh3taJr5xMFdaATdnmBwyuNR4nKDJZt3sCef5rI7ZxYeFNqXeRDK84EZobUdJax1vHbnaT5eIE6m/XixIxP0wEckRhhs/h79QQJJ8ryylH9B2Oz1ljWuCM1KZD+s28o5xG9Ber+va8rQzeDjeGn4QDmwoeP5SRPSAXOD2XmxW6yeaGlSkw9uqwMRnxj5+SEMhj1jeWeRpXmRdu6+jC1HdEZW4Kz+2+gaNVKst24owMIjmpPnm+niyWYhFNggDGrUy2dy0Rte47n2IKnUTOMNAEyDuKo3HBWr2oZu6g7csBiNLUVlnV5lBFyLxSUbv0tGxG+bM0SKq+ZCmGswO/YsiZpOaeI2/kHcVad3AbSdXsAAAAASUVORK5CYII="
                  alt="avatar"
                  class="userImg"
                />
              </div>
            </td>

            <td>
              {{ row.fullName }}
            </td>

            <td>
              {{ convertDate(row.date) }}
            </td>

            <td>
              {{ row.numberOfTry }}
            </td>

            <td>
              {{ row.score > 0 ? `${row.score}%` : 0 }}
            </td>

            <td>
              <img src="../../../assets/images/result.svg" />
            </td>
          </tr>
        </tbody>
      </table> -->
    </div>
    <b-modal id="showUserAnswer" size="xl" no-close-on-esc hide-footer centered cancel-title no-close-on-backdrop>
      <template #modal-title> پاسخ نامه {{ selectedUser.fullName }}</template>
      <div class="p-3">
        <h5>{{ userAnswer.title }}</h5>

        <div class="mt-3">
          <div v-for="(question, index) in userAnswer.questions" :key="index">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex gap-1">
                <p style="margin: 0">{{ index + 1 }}-</p>

                <p style="margin: 0">
                  {{ question.questionText }}
                </p>
              </div>

              <div style="background: rgba(153, 150, 150, 0.2); border-radius: 3px; padding: 5px 12px">
                <p style="margin: 0; color: #999696">{{ checkRightAnswer(question.answers) }} نمره</p>
              </div>
            </div>

            <div v-for="(answer, idx) in question.answers" :key="idx">
              <div
                :class="['d-flex align-items-center', { wrong_answer: answer.userSelected !== answer.isCorrect }, { correct_answer: answer.userSelected && answer.isCorrect }]"
                style="gap: 5px; padding: 3px 15px; margin: 3px 0"
              >
                <div v-if="question.questionType === 1">
                  <div :class="['checkbox', { wrong_checkbox: answer.userSelected !== answer.isCorrect }, { correct_checkbox: answer.userSelected && answer.isCorrect }]">
                    <i v-if="answer.userSelected !== answer.isCorrect || (answer.userSelected && answer.isCorrect)" class="fas fa-check" style="color: white"></i>
                  </div>
                </div>

                <div v-else>
                  <div :class="['radio', { wrong_radio: answer.userSelected !== answer.isCorrect }, { correct_radio: answer.userSelected && answer.isCorrect }]">
                    <div
                      v-if="answer.userSelected !== answer.isCorrect || (answer.userSelected && answer.isCorrect)"
                      :class="[{ wrong_radio_btn: answer.userSelected !== answer.isCorrect }, { correct_radio_btn: answer.userSelected && answer.isCorrect }]"
                    ></div>
                  </div>
                </div>
                <p style="margin: 0; padding: 8px 4px">
                  {{ answer.title }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import skillUpExaminationServices from '../../../services/skillUp/examination'
import moment from 'jalali-moment'

export default {
  components: {},
  data() {
    return {
      fields: [
        { key: 'userImage', label: '#' },
        { key: 'fullName', label: 'نام و نام خانوادگی' },
        { key: 'date', label: 'تاریخ' },
        { key: 'numberOfTry', label: 'تعداد شرکت در امتحان' },
        { key: 'score', label: 'نمره' },
        { key: 'url', label: 'نتیجه' },
      ],
      isBusy: false,

      examination: {},
      selectedUser: {},
      userAnswer: {},
      items: [],
    }
  },
  props: {
    courseSessionFileId: { type: Number, required: true },
  },
  methods: {
    goDetail(row) {
      if (this.$route.query.act === 'survey') return
      if (this.$route.query.act === 'exam') {
        this.selectedUser = row
        this.getAnswerAdmin()
        this.$bvModal.show('showUserAnswer')
      }
    },
    checkRightAnswer(array) {
      let score
      array.forEach((element) => {
        score = element.isCorrect && element.userSelected ? '+1' : '0'
      })
      return score
    },
    async getAnswerAdmin() {
      try {
        const req = await skillUpExaminationServices.getAnswerAdmin({ courseSessionFileId: this.courseSessionFileId, userId: this.selectedUser.userId })
        if (req.status === 200) this.userAnswer = req.data.data.output
      } catch (error) {
        console.log(error)
      }
    },
    async getTable() {
      this.isBusy = true
      try {
        const req = await skillUpExaminationServices.getExaminationTable(this.$route.query.fileId)
        if (req.status === 200) {
          req.data.data.output.forEach((item) => {
            this.items.push({
              fullName: item.fullName,
              userImage: item.userImage,
              date: moment(item.date).locale('fa').format('YYYY/MM/DD'),
              numberOfTry: item.numberOfTry,
              score: item.score > 0 ? `${item.score}%` : 0,
              userId: item.userId,
            })
          })
        }
        this.isBusy = false
      } catch (error) {
        console.log(error)
      }
    },
    convertDate(date) {
      let finalTime = moment(date).locale('fa').format('YYYY/M/D')
      return finalTime
    },
  },
  async mounted() {
    await this.getTable()
  },
}
</script>
<style scoped lang="scss">
.logo {
  margin-right: -20px;
}
.view-list {
  background: rgba(241, 180, 76, 0.2);
  padding: 5px 8px;
  border-radius: 4px;
  span {
    color: #f1b44c;
  }
}

.card {
  padding: 10px 15px;
}

::v-deep .custom-control .custom-control-label {
  margin-right: 5px !important;
}

::v-deep .custom-control .custom-control-input {
  border-color: #d7d7d7;
  width: 18px;
  height: 18px;
}

::v-deep .custom-control .custom-control-input:checked {
  background-color: #34c38f;
  border-color: inherit;
  color: white;
}

::v-deep .modal-content {
  height: 900px;
  overflow-y: scroll;
}

.wrong_answer {
  background: rgba(244, 106, 106, 0.15);
}

.correct_answer {
  background: rgba(52, 195, 143, 0.15);
}
.checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  border: 1px solid #d7d7d7;
}

.radio {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  border-radius: 100%;
  border: 1px solid #d7d7d7;
}

.radio_btn {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  border: 1px solid #d7d7d7;
  background-color: black;
}

.wrong_checkbox {
  background: rgba(248, 72, 72, 0.671);
}

.wrong_radio {
  border: 1px solid rgba(221, 11, 11, 0.671);
}

.wrong_radio_btn {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background-color: rgba(221, 11, 11, 0.671);
}

.correct_radio_btn {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background-color: #34c38f;
}

.correct_checkbox {
  background: #34c38f;
}

.correct_radio {
  color: #34c38f;
}
</style>
